import React from 'react';
import { cx } from './_cx';

/**
 * Card (UI primitive)
 *
 * Standard surface for panels/forms/sections.
 */
export function Card({ as, className, ...props }) {
  const Component = as || 'div';
  return <Component className={cx('pv-card', className)} {...props} />;
}

